export default {
    indexWorkLoadHistories:             { method: 'get',    url: 'teacher_work_load_histories'},
    storeWorkLoadHistory:               { method: 'post',   url: 'teacher_work_load_histories'},
    updateWorkLoadHistory:              { method: 'put',    url: 'teacher_work_load_histories/{id}'},
    destroyWorkLoadHistory:             { method: 'delete', url: 'teacher_work_load_histories/{id}'},
    generateWorkLoadHistory:            { method: 'post',   url: 'teacher_work_load_histories/generate'},
}